import { observe } from "mobx";
import { Observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Pagination } from "../..";
import { useTranslation } from "../../hooks/useTranslation";
import { SortableTable } from "../../SortableTable";
import { ColorOptions } from "../../types";
import { Article } from "../Article";
import { ArticleHeader } from "../ArticleHeader/ArticleHeader";
const INTERCEPT_RELOAD_MS = 250;
export const TABLE_LIMIT = 30;
export function ArticleTable(props) {
    if (props.table.form) {
        return React.createElement(Observer, null, () => React.createElement(ObservableArticleTable, { ...props }));
    }
    return React.createElement(ArticleTableContents, { ...props });
}
function ObservableArticleTable(props) {
    const { values, name, type } = props.table.form;
    const [selected, setSelected] = useState(type === "checkbox" && values[name] ? `${values[name].length}` : "0");
    observe(values, (changes) => setSelected(`${changes.object[name].length}` || "0"));
    return (React.createElement(ArticleTableContents, { ...props, selected: type === "checkbox" ? selected : undefined }));
}
function ArticleTableContents({ title, subtitle, pageInfo, extra, create, children, filters, loading, table, pagination, search, selected, titleLevel, tooltip, }) {
    const t = useTranslation();
    const [reload, setReload] = useState(false);
    useEffect(() => {
        if (reload) {
            setTimeout(() => setReload(false), INTERCEPT_RELOAD_MS);
        }
    }, [reload]);
    const handleSetOffset = (offset) => {
        setReload(true);
        pagination.setOffset(offset);
    };
    const handleOnSort = (column, direction) => {
        setReload(true);
        table.onSort && table.onSort(column, direction);
    };
    return (React.createElement(Article, null,
        React.createElement(ArticleHeader, { title: title || t("Results"), subtitle: subtitle, pageInfo: pageInfo, extra: extra, create: create, loading: loading || table.loading, filters: filters, search: search, hideResults: table.form?.type === "checkbox", tooltip: tooltip, label: selected
                ? {
                    text: `${selected}/${pageInfo?.totalRecords ?? (table?.form?.total || "-")} ${t("selected")}`,
                    color: ColorOptions.Blue,
                }
                : undefined, titleLevel: titleLevel }, children),
        React.createElement(SortableTable, { ...table, headings: table.headings, data: table.data, onSort: handleOnSort, loading: loading || table.loading || reload }),
        pageInfo &&
            pageInfo.totalRecords > (pagination.limit || TABLE_LIMIT) && (React.createElement(Pagination, { offset: pagination.offset, totalRecords: pageInfo.totalRecords, limit: pagination.limit || TABLE_LIMIT, setOffset: handleSetOffset, maxPagesDisplayed: 7 }))));
}
